import { lightBlue as lightBlueMuiColor } from '@mui/material/colors';

const lightBlue = {
  ...lightBlueMuiColor,
  C292: '#53b1fd',
};

export default lightBlue;
